import { GetScopeSearchRequest, GetScopeValuesRequest, ScopeItem, TopologyService } from "../Scopes.types";
import { ScopeValueMapping, useORPCClient } from "Core/oRPC";

import { nonNullable } from "Shared/Utils/Types";

export const useMaasTopologyService = (): TopologyService => {
    const { maasApi } = useORPCClient();

    return {
        getScopeValueOptions: async (request: GetScopeValuesRequest): Promise<ScopeItem[]> => {
            const currentScopeTarget = request.currentScopeTarget;
            const currentSignalId = request.context?.SignalId;
            const currentScopeTargetIndex = request.selectedScopesSoFar?.findIndex((x) => x.ScopeType === currentScopeTarget.ScopeType) ?? -1;
            const parentScopes = currentScopeTargetIndex >= 0 ? request.selectedScopesSoFar?.slice(0, currentScopeTargetIndex) : request.selectedScopesSoFar;
            const customFilters =
                parentScopes
                    ?.filter((x) => x.Value)
                    .map((x) => `${x.ScopeType}:${x.Value}`)
                    .join(";") ?? "";
            const resp = await maasApi.getGetScopeValueMappingV2({
                signalId: currentSignalId,
                scopeDisplayName: currentScopeTarget.ScopeType,
                customFilters
            });
            if (!Array.isArray(resp)) {
                return [];
            }
            return resp
                .map((item: ScopeValueMapping) => ({
                    ScopeType: currentScopeTarget.ScopeType,
                    Value: item.StandardValue ?? item.RealValue
                }))
                .filter(nonNullable);
        },
        getScopeSearch: (request: GetScopeSearchRequest): ScopeItem[] | Promise<ScopeItem[]> => [{ ScopeType: "", Value: "" }]
    };
};
